import { signatureSlotKey } from '../signatureSlotKey';
import type { SignatureSlotTuple } from '../signatureSlotKey';
import { duplicatesBy, flowAnchors, headerRowFlowAnchors, signatureAttrsOf } from './anchors';
import type { DocumentFlowDoc, FlowSignature } from './schema';

/**
 * Anchors in a table's HEADER row, which a stamp cannot go in: the row repeats on every
 * continuation page, reserving the stamp's height on each while only one stamp is drawn. The
 * renderer de-duplicates, but it cannot undo the blank space, so the save refuses it.
 */
export const headerRowFlowSignatureSlots = (doc: DocumentFlowDoc): FlowSignature['attrs'][] =>
	signatureAttrsOf(headerRowFlowAnchors(doc));

/** Every signature anchor the document holds, in document order, however deeply nested. */
export const flowSignatureSlots = (doc: DocumentFlowDoc): FlowSignature['attrs'][] =>
	signatureAttrsOf(flowAnchors(doc));

/**
 * Slots the document places more than once. A slot holds one anchor row and one box per instance,
 * so the second anchor's stamp silently never happens.
 */
export const duplicateFlowSignatureSlots = (doc: DocumentFlowDoc): SignatureSlotTuple[] =>
	duplicatesBy(flowSignatureSlots(doc), signatureSlotKey);
